import { Component, Input, OnInit } from '@angular/core';
import { IAlertaPainelInterface } from '../../../shared/Util';


@Component({
    selector: 'app-pill-alertas',
    template: `<img [src]="'assets/img/icons/' + srcPill + '.svg'">`
})
export class PillAlertasComponent implements OnInit {

  @Input() alerta: IAlertaPainelInterface;
  
  srcPill = '';
  ngOnInit(): void {
    this.srcPill =  this.determinarStatusPill(this.alerta.IdStatus, this.alerta.Visualizado);
  }

  SrcPillEnum = {
    NOVO_ALERTA:  'pill_novo_alerta' ,
    ALERTA_VISUALIZADO: 'pill_alerta_visualizado',
    OC_EM_ANDAMENTO: 'pill_oc_andamento',
    OC_FINALIZADA: 'pill_oc_finalizada'
  }



  determinarStatusPill(idSituacao, visualizado) {
    if (idSituacao == 3) {
        return this.SrcPillEnum.OC_FINALIZADA;
    } else if (idSituacao == 1 || idSituacao == 2) {
        return this.SrcPillEnum.OC_EM_ANDAMENTO;
    } else if (idSituacao === null) {
        if (visualizado == 0) {
            return this.SrcPillEnum.NOVO_ALERTA;
        } else if (visualizado == 1) {
            return this.SrcPillEnum.ALERTA_VISUALIZADO;
        }
    }

  }
}
